import NewsletterSection from '@/components/NewsletterSection'
import BlogCard from '@/components/BlogCard'
import { getCoreValues, getLatestBlogs } from '@/lib/api'
import BlueHero from '@/components/BlueHero'

export default async function AboutCoreValues() {
  const [data, blogs] = await Promise.all([getCoreValues(), getLatestBlogs()])
  const values = data?.our_core_values || []
  const latestBlogs = blogs?.slice(0, 3) || []

  const svgIcons = [
    <svg key="1" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.6"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
    <svg key="2" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.6"><circle cx="12" cy="12" r="4"/><line x1="12" y1="2" x2="12" y2="4"/><line x1="12" y1="20" x2="12" y2="22"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="2" y1="12" x2="4" y2="12"/><line x1="20" y1="12" x2="22" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>,
    <svg key="3" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.6"><polyline points="22,7 13.5,15.5 8.5,10.5 2,17"/><polyline points="16,7 22,7 22,13"/></svg>,
    <svg key="4" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.6"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
  ]

  const fallback = [
    { id: 1, title: 'Collaboration', description: 'Arnessing The Power Of Partnerships To Accomplish Mutual Success.', image: '', quotes: '' },
    { id: 2, title: 'Innovation', description: 'Committed To Advancing New Ideas And Cutting-Edge Solutions.', image: '', quotes: '' },
    { id: 3, title: 'Growth', description: 'Focusing On Nurturing Both Individual And Shared Development.', image: '', quotes: '' },
    { id: 4, title: 'Impact', description: 'Driven To Make A Significant In Entrepreneurial Community.', image: '', quotes: '' },
  ]
  const displayValues = values.length > 0 ? values : fallback

  return (
    <>
      {/* Blue Hero */}
      <BlueHero title="MR. ALRIFAI CORE VALUES" />

      {/* THE PILLARS */}
      <section style={{ background: '#07090e', padding: '72px 0' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 40px', textAlign: 'center' }}>
          <h2 style={{ fontSize: '20px', fontWeight: 900, color: '#fff', letterSpacing: '0.12em', marginBottom: '20px' }}>THE PILLARS OF GHASSAN&apos;S APPROACH</h2>
          <p style={{ fontSize: '13.5px', color: 'rgba(255,255,255,0.60)', lineHeight: 1.95, maxWidth: '680px', margin: '0 auto 64px' }}>
            Ghassan&apos;s Core Values Are At The Heart Are Collaboration, Innovation, Growth, And Impact. He Believes In The Strength Of Partnership And Shared Success, He Is Committed To Embracing New Ideas And Pioneering Cutting-Edge Solutions.
          </p>
          {/* 2x2 grid */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '56px 80px', maxWidth: '620px', margin: '0 auto' }}>
            {displayValues.map((v, i) => (
              <div key={v.id} style={{ textAlign: 'center' }}>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '12px' }}>{svgIcons[i % svgIcons.length]}</div>
                <div style={{ fontSize: '15px', fontWeight: 800, color: '#f97316', marginBottom: '10px' }}>{v.title}</div>
                <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.52)', lineHeight: 1.8 }}>{v.description || v.quotes}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Blog */}
      <section className="relative overflow-hidden" style={{ background: '#161920', padding: '64px 0' }}>
        <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage: 'url(/arab-pattern-bg.jpg)', backgroundSize: 'cover', opacity: 0.07, zIndex: 0 }} />
        <div className="absolute inset-0 pointer-events-none" style={{ background: 'rgba(16,18,26,0.80)', zIndex: 0 }} />
        <div className="relative z-10" style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 32px' }}>
          <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#fff', textAlign: 'center', marginBottom: '10px' }}>From His Blog</h2>
          <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.48)', textAlign: 'center', lineHeight: 1.85, maxWidth: '520px', margin: '0 auto 40px' }}>Dive Into The Blog For The Latest Updates, Expert Opinions, And Detailed Information On Our Projects.</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '18px' }}>
            {(latestBlogs.length > 0 ? latestBlogs : [
              { id: '1', title: 'Fly High With Our Exclusive Travel Tips', image: '/blog-homs.jpg', date: '24/08/2024', category: 'Travel', likes: 23, comments: 5 },
              { id: '2', title: 'Fly High With Our Exclusive Travel Tips', image: '/blog-steve-jobs.jpg', date: '24/08/2024', category: 'Travel', likes: 23, comments: 5 },
              { id: '3', title: 'Fly High With Our Exclusive Travel Tips', image: '/investment-wealth.jpg', date: '24/08/2024', category: 'Travel', likes: 23, comments: 5 },
            ]).map((p: any) => (
              <BlogCard key={p.id} id={String(p.id)} title={p.title} image={p.image} date={p.created_at || p.date} category={p.category || ''} likes={p.likes_count ?? p.likes ?? 0} comments={p.comments_count ?? p.comments ?? 0} />
            ))}
          </div>
        </div>
      </section>
      <NewsletterSection />
    </>
  )
}
